if (typeof ProductPage !== "function") {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      this.productGallery = this.querySelector(".product-gallery");
      this.cartControls = this.querySelector("[data-product-cart-controls]");
      this.currentCartItem = null;
      this.cartSyncRequest = 0;

      // qty helper

      this.addEventListener("click", (event) => {
        if (event.target.classList.contains("product__quantity")) {
          event.target.select();
          return;
        }

        const button = event.target.closest("[data-product-quantity-adjust]");
        if (!button || !this.contains(button)) return;

        const selector = button.closest("[data-product-quantity-selector]");
        const input = selector?.querySelector(".product__quantity");
        if (!input) return;

        const min = parseInt(input.getAttribute("min"), 10) || 1;
        const maxAttribute = input.getAttribute("max");
        const max = maxAttribute ? parseInt(maxAttribute, 10) : null;
        const current = parseInt(input.value, 10) || min;
        const direction =
          button.dataset.productQuantityAdjust == "increase" ? 1 : -1;

        if (
          selector
            .closest("[data-product-cart-controls]")
            ?.classList.contains("is-in-cart")
        ) {
          this._changeCartQuantity(direction, button);
          return;
        }

        let next = Math.max(current + direction, min);

        if (max !== null && !isNaN(max)) {
          next = Math.min(next, max);
        }

        input.value = next;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });

      if (this.cartControls) {
        this._setupCartControls();
      }

      this._setupVariantOptionWraps();

      // Product variant event listener for theme specific logic

      const productVariants = this.querySelector("product-variants");
      if (productVariants) {
        productVariants.addEventListener(
          "VARIANT_CHANGE",
          this.onVariantChangeHandler.bind(this),
        );
        this.onVariantChangeHandler({ target: productVariants });
      }

      // Look at add to cart button for changes

      if (this.querySelector(".product__add-to-cart")) {
        const addToCartHolder = this.querySelector(
          ".product__cart-actions-holder",
        );
        new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            if (mutation.attributeName == "class") {
              addToCartHolder.classList.remove("disabled");
              addToCartHolder.classList.remove("working");
              if (mutation.target.classList.contains("disabled")) {
                addToCartHolder.classList.add("disabled");
              }
              if (mutation.target.classList.contains("working")) {
                addToCartHolder.classList.add("working");
                mutation.target.setAttribute("aria-busy", "true");
              } else {
                mutation.target.setAttribute("aria-busy", "false");
              }
            }
          }
        }).observe(this.querySelector(".product__add-to-cart"), {
          attributes: true,
          childList: false,
          subtree: false,
        });
        if (
          this.querySelector(".product__add-to-cart").classList.contains(
            "disabled",
          )
        ) {
          addToCartHolder.classList.add("disabled");
        }
      }

      // Helper events for different media

      this.productGallery.addEventListener("change", (e) => {
        if (
          this.productGallery.items[this.productGallery.index].dataset
            .productMediaType == "model"
        ) {
          setTimeout(() => {
            this.productGallery.toggleDragging(false);
          }, 15);
          if (this.xrButton) {
            this.xrButton.setAttribute(
              "data-shopify-model3d-id",
              this.productGallery.items[this.productGallery.index].dataset
                .mediaId,
            );
          }
        }
        this._pauseAllMedia();
      });

      // Add to cart event

      if (
        !document.body.classList.contains("template-cart") &&
        KROWN.settings.cart_action == "overlay"
      ) {
        let addToCartEnter = false;
        if (this.querySelector(".product__add-to-cart")) {
          this.querySelector(".product__add-to-cart").addEventListener(
            "keyup",
            (e) => {
              if (e.keyCode == window.KEYCODES.RETURN) {
                addToCartEnter = true;
              }
            },
          );
        }

        if (this.querySelector(".product__form")) {
          this.querySelector(".product__form").addEventListener(
            "add-to-cart",
            () => {
              document.getElementById("site-cart-sidebar").show();
              if (addToCartEnter) {
                setTimeout(() => {
                  document
                    .querySelector("#site-cart-sidebar .close-sidebar")
                    .focus();
                }, 200);
              }
            },
          );
        }
      }

      // Check for models

      const models = this.querySelectorAll("product-model");
      if (models) {
        window.ProductModel.loadShopifyXR();
        this.xrButton = this.querySelector(".product-gallery__view-in-space");
      }
    }

    onVariantChangeHandler(e) {
      let variant = e.target.currentVariant;

      // variant images

      if (variant && variant.featured_media != null) {
        let variantImg = this.productGallery.querySelector(
          '.product-gallery__item[data-media-id="' +
            variant.featured_media.id +
            '"]',
        );
        if (variantImg) {
          if (this.productGallery.classList.contains("js-enabled")) {
            this.productGallery.changeSlide(parseInt(variantImg.dataset.index));
          } else {
            this.productGallery.dataset.initialIndex = variantImg.dataset.index;
          }
        }
      }

      if (this.skipNextCartSync) {
        this.skipNextCartSync = false;
      } else {
        this._syncSelectedVariantCartState();
      }
    }

    _setupCartControls() {
      const productForm = this.cartControls.closest("product-form");
      const form = this.cartControls.closest("form");
      const initialCartItems = this.querySelector(
        "[data-product-cart-items]",
      );

      if (initialCartItems) {
        try {
          this._renderCartState(
            this._findSelectedCartItem({
              items: JSON.parse(initialCartItems.textContent),
            }),
          );
        } catch {}
      }
      this.skipNextCartSync = true;

      this.cartControls.addEventListener("click", (event) => {
        const addToCart = event.target.closest(
          "[data-js-product-add-to-cart]",
        );

        if (!addToCart || !this.cartControls.classList.contains("is-in-cart")) {
          return;
        }

        event.preventDefault();
        document.location.href = KROWN.settings.routes.cart_url;
      });

      productForm?.addEventListener("add-to-cart", () => {
        const quantity = Number(
          this.cartControls.querySelector(".product__quantity")?.value,
        );
        const variantId = form?.querySelector('input[name="id"]')?.value;

        this._renderCartState({
          key: "",
          variant_id: variantId,
          quantity: quantity || 1,
        });
        this.cartControls.classList.add("is-cart-loading");
        this._syncSelectedVariantCartState({ clearLoading: true });
      });

      form?.addEventListener("change", (event) => {
        if (
          event.target.name == "selling_plan" ||
          event.target.classList.contains("appstle_select")
        ) {
          window.setTimeout(() => this._syncSelectedVariantCartState(), 0);
        }
      });

      document.addEventListener("krown:cart:update", (event) => {
        if (event.detail?.source == "product-page") return;
        this._syncSelectedVariantCartState();
      });
      document.addEventListener("cart:updated", (event) => {
        if (event.detail?.source == "product-page") return;
        this._syncSelectedVariantCartState();
      });
      document.addEventListener("cart:refresh", () => {
        this._syncSelectedVariantCartState();
      });
    }

    _getSelectedSellingPlanId() {
      const cartControls =
        this.querySelector("[data-product-cart-controls]") || this.cartControls;
      const form = cartControls?.closest("form");
      const selectedPlan = form?.querySelector(
        'input[name="selling_plan"]:checked',
      );

      if (!selectedPlan) return "";

      const selectedOption = selectedPlan.closest(
        ".appstle_subscription_wrapper_option",
      );
      const selectedFrequency = selectedOption?.querySelector(
        ".appstle_select",
      );

      return String(
        selectedFrequency?.value ||
          selectedPlan.value ||
          selectedPlan.dataset.appstleRealValue ||
          "",
      );
    }

    _findSelectedCartItem(cart) {
      const cartControls =
        this.querySelector("[data-product-cart-controls]") || this.cartControls;
      const variantId = cartControls
        ?.closest("form")
        ?.querySelector('input[name="id"]')?.value;
      const sellingPlanId = this._getSelectedSellingPlanId();

      if (!variantId) return null;

      return (
        cart.items.find((item) => {
          const itemSellingPlanId = String(
            item.selling_plan_id ||
              item.selling_plan_allocation?.selling_plan?.id ||
              "",
          );

          return (
            String(item.variant_id) == String(variantId) &&
            itemSellingPlanId == sellingPlanId
          );
        }) || null
      );
    }

    _syncSelectedVariantCartState({ clearLoading = false } = {}) {
      this.cartControls =
        this.querySelector("[data-product-cart-controls]") || this.cartControls;
      if (!this.cartControls) return;

      const requestId = ++this.cartSyncRequest;

      fetch(`${KROWN.settings.routes.cart_url}.js`, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store",
      })
        .then((response) => response.json())
        .then((cart) => {
          if (requestId != this.cartSyncRequest) return;
          this._renderCartState(this._findSelectedCartItem(cart));
        })
        .catch(() => {})
        .finally(() => {
          if (clearLoading && requestId == this.cartSyncRequest) {
            this.cartControls.classList.remove("is-cart-loading");
          }
        });
    }

    _renderCartState(item) {
      this.cartControls =
        this.querySelector("[data-product-cart-controls]") || this.cartControls;
      const quantitySelector = this.cartControls?.querySelector(
        "[data-product-quantity-selector]",
      );
      const quantityInput = quantitySelector?.querySelector(
        ".product__quantity",
      );
      const addToCart = this.cartControls?.querySelector(
        "[data-js-product-add-to-cart]",
      );
      const addToCartText = addToCart?.querySelector(
        "[data-js-product-add-to-cart-text]",
      );
      const isInCart = Boolean(item);
      const inCartLabel = this.cartControls?.dataset.inCartLabel || "";

      this.currentCartItem = item;
      this.cartControls?.classList.toggle("is-in-cart", isInCart);

      if (item) {
        this.cartControls.dataset.cartItemKey = item.key || "";
        this.cartControls.dataset.cartVariantId = item.variant_id || "";
      } else {
        delete this.cartControls.dataset.cartItemKey;
        delete this.cartControls.dataset.cartVariantId;
      }

      if (quantityInput) {
        quantityInput.readOnly = isInCart;
        quantityInput.min = isInCart ? "0" : "1";
        quantityInput.value = isInCart ? item.quantity : 1;
      }

      if (!addToCart || !addToCartText) return;

      if (isInCart) {
        if (addToCartText.textContent.trim() != inCartLabel) {
          this.addToCartLabel = addToCartText.textContent;
        }
        addToCartText.textContent = inCartLabel;
        addToCart.disabled = false;
        addToCart.setAttribute("aria-disabled", "false");
      } else {
        if (addToCartText.textContent.trim() == inCartLabel) {
          addToCartText.textContent =
            this.addToCartLabel ||
            KROWN.settings.locales.products_add_to_cart_button;
        }
        const isUnavailable = addToCart.classList.contains("disabled");
        addToCart.disabled = isUnavailable;
        addToCart.setAttribute("aria-disabled", String(isUnavailable));
      }
    }

    _changeCartQuantity(direction, loadingButton) {
      this.cartControls =
        this.querySelector("[data-product-cart-controls]") || this.cartControls;
      const quantitySelector = loadingButton.closest(
        "[data-product-quantity-selector]",
      );
      const quantity = Number(
        quantitySelector?.querySelector(".product__quantity")?.value,
      );
      const currentItem = this.currentCartItem || {
        key: this.cartControls?.dataset.cartItemKey,
        variant_id: this.cartControls?.dataset.cartVariantId,
        quantity,
      };

      if (
        !currentItem.key ||
        this.cartControls.classList.contains("working")
      ) {
        return;
      }

      const nextQuantity = Math.max(Number(currentItem.quantity) + direction, 0);
      const itemKey = currentItem.key;
      const variantId = currentItem.variant_id;
      this.cartControls.classList.add("working");
      loadingButton.classList.add("is-loading");
      quantitySelector?.setAttribute("aria-busy", "true");

      fetch(`${KROWN.settings.routes.cart_change_url}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify({ id: itemKey, quantity: nextQuantity }),
      })
        .then(async (response) => {
          const cart = await response.json();
          if (!response.ok) throw new Error(cart.description || cart.message);
          return cart;
        })
        .then((cart) => {
          const updatedItem = this._findSelectedCartItem(cart);
          this._renderCartState(updatedItem);
          return Promise.resolve(window.refreshCart?.(false)).then(
            () => updatedItem,
          );
        })
        .then((updatedItem) => {
          KROWN.functions.eventDispatcher("krown:cart:update", {
            itemKey,
            itemQty: updatedItem?.quantity || 0,
            itemVariantId: variantId,
            source: "product-page",
          });
          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: {
                itemKey,
                quantity: updatedItem?.quantity || 0,
                source: "product-page",
              },
            }),
          );
        })
        .catch((error) => {
          KROWN.functions.eventDispatcher("krown:cart:error", {
            error: error.message || KROWN.settings.locales.cart_general_error,
          });
          this._syncSelectedVariantCartState();
        })
        .finally(() => {
          this.cartControls.classList.remove("working");
          loadingButton.classList.remove("is-loading");
          quantitySelector?.setAttribute("aria-busy", "false");
        });
    }

    _setupVariantOptionWraps() {
      const containers = this.querySelectorAll(
        '.product-variant__container[data-js-product-variant-container="radio"]',
      );

      if (!containers.length) return;

      this._requestVariantOptionWrapSync();

      if ("ResizeObserver" in window) {
        this.variantOptionWidths = new WeakMap();
        this.variantOptionResizeObserver = new ResizeObserver((entries) => {
          let shouldSync = false;

          entries.forEach((entry) => {
            const width = Math.round(entry.contentRect.width);
            if (this.variantOptionWidths.get(entry.target) !== width) {
              this.variantOptionWidths.set(entry.target, width);
              shouldSync = true;
            }
          });

          if (shouldSync) {
            this._requestVariantOptionWrapSync();
          }
        });

        containers.forEach((container) => {
          this.variantOptionResizeObserver.observe(container);
        });
      } else {
        window.addEventListener("resize", () => {
          this._requestVariantOptionWrapSync();
        });
      }
    }

    _requestVariantOptionWrapSync() {
      if (this.variantOptionWrapFrame) {
        window.cancelAnimationFrame(this.variantOptionWrapFrame);
      }

      this.variantOptionWrapFrame = window.requestAnimationFrame(() => {
        this._syncVariantOptionWraps();
      });
    }

    _syncVariantOptionWraps() {
      this.querySelectorAll(
        '.product-variant__container[data-js-product-variant-container="radio"]',
      ).forEach((container) => {
        if (container.querySelector(".product-variant__item--color")) return;

        const items = [...container.children].filter((item) =>
          item.classList.contains("product-variant__item"),
        );

        if (items.length < 2) return;

        container.classList.remove("product-variant__container--wrapped");

        const firstTop = Math.round(items[0].getBoundingClientRect().top);
        const isWrapped = items.some((item) => {
          return Math.round(item.getBoundingClientRect().top) !== firstTop;
        });

        container.classList.toggle(
          "product-variant__container--wrapped",
          isWrapped,
        );
      });
    }

    _pauseAllMedia() {
      document
        .querySelectorAll(".product-gallery .js-youtube")
        .forEach((video) => {
          video.contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*",
          );
        });
      document
        .querySelectorAll(".product-gallery .js-vimeo")
        .forEach((video) => {
          video.contentWindow.postMessage('{"method":"pause"}', "*");
        });
      document
        .querySelectorAll(".product-gallery video")
        .forEach((video) => video.pause());
      document
        .querySelectorAll(".product-gallery product-model")
        .forEach((model) => {
          if (model.modelViewerUI) model.modelViewerUI.pause();
        });
    }
  }

  if (typeof customElements.get("product-page") == "undefined") {
    customElements.define("product-page", ProductPage);
  }
}
